import styled from 'styled-components';
import Pagination from '../stats_components/Pagination';

const BoxHeaderPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);

  & .section {
    height: 100%;
    width: 20%;

    &.box-pagination {
      align-items: center;
      width: 60%;
      margin: 0;
    }
  }

  & .box-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 50px;
    gap: 12px;
  }
`;

const BoxYearSelection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  & .select-container {
    width: 80%;

    & select {
      width: 100%;
      height: 40px;
      background: rgba(255, 255, 255, 0.08);
      border: 1px solid rgba(255, 255, 255, 0.25);
      border-radius: 8px;
      color: white;
      font-size: 14px;
      padding: 0 10px;
      cursor: pointer;
      transition: border-color 0.2s ease, background 0.2s ease;

      &:focus {
        outline: none;
        border-color: rgba(255, 255, 255, 0.6);
        background: rgba(255, 255, 255, 0.12);
      }

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }

      & option {
        background: rgb(80, 15, 15);
        color: white;
      }
    }
  }
`;

const BoxTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;

  & h1 {
    text-align: center;
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 2rem;
    margin: 0;
    color: white;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
  }
`;

const BoxSearchName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100%;

  & input {
    width: 95%;
    height: 40px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.25);
    border-radius: 8px;
    padding: 0 12px;
    color: white;
    font-size: 14px;
    transition: border-color 0.2s ease, background 0.2s ease;

    &::placeholder {
      color: rgba(255, 255, 255, 0.4);
    }

    &:focus {
      outline: none;
      border-color: rgba(255, 255, 255, 0.6);
      background: rgba(255, 255, 255, 0.12);
    }
  }
`;

const HeaderMostFightWinsComponent = (
    {
        year, handleYearChange, isLoading, searchInput, handleSearchInput, years, title, currentPage, lastPage, onPageChange
    }
    ) => {

    return (
        <BoxHeaderPage className='box-header-page'>

          <BoxTitle className='box-title'>
            <h1 className='title'>{title}</h1>
          </BoxTitle>

          <div className='box-actions w-100'>
            <BoxYearSelection className='box-selection-year section'>
              <div className="select-container">
                <select
                  value={year}
                  onChange={handleYearChange}
                  disabled={isLoading}
                >
                  {years.map(year => (
                    <option key={year} value={year}>
                      {year === 'globale' ? 'Globale' : year}
                    </option>
                  ))}
                </select>
              </div>
            </BoxYearSelection>

            <Pagination
              currentPage={currentPage}
              lastPage={lastPage}
              onPageChange={onPageChange}
              className='box-pagination section'
            />

            <BoxSearchName className='box-search-name section'>
              <input
                type="text"
                placeholder="Cerca (minimo 3 caratteri)"
                value={searchInput}
                onChange={handleSearchInput}
              />
            </BoxSearchName>
          </div>

        </BoxHeaderPage>
    );
};

export default HeaderMostFightWinsComponent;
